// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"256":"purchase","596":"404"}[chunkId] || chunkId) + "." + {"107":"68e7f51f","256":"7704a6f6","494":"8c7d2db0","596":"7554082c","884":"c2093966","951":"83732503"}[chunkId] + ".js";
};